import { ChangeDetectionStrategy, OnInit, Component, Input } from '@angular/core';
import { Money } from '~shared/models';
import { OrderHistoryItem } from '~app/modules/account/modules/orders-history/models';

@Component({
  selector: 'app-order-history-details-payment',
  templateUrl: './order-history-details-payment.component.html',
  styleUrls: ['./order-history-details-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHistoryDetailsPaymentComponent implements OnInit {
  @Input() order: OrderHistoryItem;
  @Input() isEntrepreneur: boolean;

  public subtotal: Money;
  public shippingCost: Money;
  public totalGross: Money;
  public totalNet: Money;
  public totalDiscount: Money;
  public grandTotal: Money;
  public vat: Money;

  public get isDiscountApplied(): boolean {
    const totalDiscount = +this.order?.totals.totalDiscount.amount;
    return totalDiscount > 0;
  }

  ngOnInit() {
    this.setOrderData();
  }

  setOrderData(): void{
    const {subtotal, shippingCost, totalGross, totalNet, totalDiscount, grandTotal, vat} = this.order?.totals;
    this.subtotal = subtotal;
    this.shippingCost = shippingCost;
    this.totalGross = totalGross;
    this.totalNet = totalNet;
    this.totalDiscount = totalDiscount;
    this.grandTotal = grandTotal;
    this.vat = vat;
  }
}
